import { parseChapterContent } from 'api/parsers/parseChapterContent';
import { fetch } from 'api/typedFetch';

import { getAppDataOptions } from 'hooks/data/useAppData';

import { queryClient } from '../../queryClient';

export const getData = async (id: string, chapterId?: string) => {
  const params = new URLSearchParams();

  if (chapterId !== undefined) {
    params.append('chapter_id', chapterId);
  }

  const response = await fetch('GET_CHAPTER_CONTENT', { params });

  const data = await response.json();

  const app = await queryClient.ensureQueryData(getAppDataOptions({ id }));

  return data
    .map((item, i) => {
      return parseChapterContent(item, app, i);
    })
    .filter((item, i) => {
      if (item === null) {
        console.warn('Failed to parse chapter content at index', i, 'in', data);
      }

      return item !== null;
    });
};
